import { Statistic } from "../ui/statistic";
import { Plus, Minus } from "lucide-react";

const CustomStatistic = ({
  title,
  value,
  type = 1,
  className,
}) => {
  // 색상 결정 로직
  let valueClassName = "text-foreground";
  if (value > 0) valueClassName = "text-red-600";
  if (type === 0 || value < 0) valueClassName = "text-blue-600";
  if (type === 2) valueClassName = "text-foreground";

  const prefix =
    value === 0 || type === 2 ? null : value > 0 && type !== 0 ? (
      <Plus className="size-3.5" />
    ) : (
      <Minus className="size-3.5" />
    );

  return (
    <Statistic
      className={className}
      title={title}
      value={Math.abs(value)}
      prefix={prefix}
      valueClassName={valueClassName}
    />
  );
};

export default CustomStatistic;
